import React from 'react';
import { Button, Typography, Grid, Box } from '@mui/material';
import {
  LandingBarContainer,
  LandingLogo,
  StyledContainer,
  HeroSection,
  HeroText,
  BrandSection,
  WhyChooseSection,
  WorkflowSection,
  FooterSection,
  LandingImage,
  BrandImage,
  WhyChooseImage,
  WhyChooseGrid,
  WhyChooseItem,
} from '../styles/LandingPage';
import Popup from '../components/Popup';
import FloatingChatButton from '../components/FloatingChatBtn';

import LandingImage1 from '../assets/images/landing/landing-image1.png';
import LandingImage2 from '../assets/images/landing/landing-image2.png';
import LandingImage3 from '../assets/images/landing/landing-image3.png';
import brands from '../utils/brands';
import svgs from '../utils/whychoose';
import Logo from '../assets/images/logo/connit-learn.png';


const LandingPage = ({ onGetStarted }) => {
  return (
    <>
      
      {/*Popup Section*/}
      <Popup />

      {/* Header Section */}
      <LandingBarContainer>
        <LandingLogo src={Logo} alt="Workflow" />
        <Button size="large" variant="contained" sx={{ backgroundColor: '#2C5296', color: '#fff' }}>
          Sign In
        </Button>
      </LandingBarContainer>

      <StyledContainer>
        {/* Hero Section */}
        <HeroSection>
          <HeroText>
            <Typography variant="h3" sx={{ mb: 2, fontWeight: '700' }}>
              Smart <span style={{ color: '#FF5733' }}>AI Assistance</span> for Gas & Oil Operations
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 4, fontWeight: 'bold' }}>
              Boost productivity, streamline operations, and manage compliance seamlessly with
              Genie AI—your innovative and reliable solution for the oil and gas industry.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ backgroundColor: '#FF5733' }}
              onClick={onGetStarted}
            >
              Get Started Now
            </Button>
          </HeroText>
          <LandingImage src={LandingImage1} alt="Man working" />
          <FloatingChatButton />
        </HeroSection>

        <BrandSection>
          <Typography variant="h4" sx={{ mb: 4, fontWeight: '700' }}>
            Trusted By The World’s Largest Global Brands
          </Typography>
          <Grid container spacing={5}>
            { brands.map((brand, index) => (
              <Grid item xs={6} sm={4} md={3} lg={2} key={index}> 
              <BrandImage src={brand.image} alt={brand.alt} />
            </Grid>
            ))}
          </Grid>
        </BrandSection>


        {/* Why Choose Section */}
        <WhyChooseSection>
          <LandingImage src={LandingImage2} alt="Worker with AI HUD" />
          <Box sx={{ maxWidth: '600px' }}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: '700' }}>
              Why Choose Our AI-Powered Chatbot for Oil and Gas Excellence?
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 3, fontWeight: 'bold' }}>
              Boost efficiency in the oil and gas industry with our AI chatbot.
              Streamline operations, automate tasks, and enhance decision-making for excellence.
            </Typography>
            <WhyChooseGrid>
              <WhyChooseItem>
                <WhyChooseImage src={svgs[0].image} alt={svgs[0].alt} />
                <Typography variant="subtitle2" sx={{ textAlign: 'left'}}>Automates tasks, freeing your team for critical work</Typography> 
              </WhyChooseItem>
              <WhyChooseItem>
                <WhyChooseImage src={svgs[3].image} alt={svgs[3].alt} />
                <Typography variant="subtitle2" sx={{ textAlign: 'left'}}>Integrates with popular technologies and frameworks</Typography>
              </WhyChooseItem>
              <WhyChooseItem>
                <WhyChooseImage src={svgs[1].image} alt={svgs[1].alt} />
                <Typography variant="subtitle2" sx={{ textAlign: 'left'}}>Instantly gain actionable data for smarter decisions</Typography>
              </WhyChooseItem>
              <WhyChooseItem>
                <WhyChooseImage src={svgs[2].image} alt={svgs[2].alt} />
                <Typography variant="subtitle2" sx={{ textAlign: 'left'}}>Fully adaptable for both desktop and mobile use</Typography>
              </WhyChooseItem>
            </WhyChooseGrid>
          </Box>
        </WhyChooseSection>

        {/* Explore Workflow Section */}
        <WorkflowSection>
          <Box sx={{ maxWidth: '600px' }}>
            <Typography variant="body2" sx={{ mb: 2, fontWeight: '700', color: '#2C5296' }}>
              WORKFLOW LIKE NEVER BEFORE
            </Typography>
            <Typography variant="h4" sx={{ mb: 2, fontWeight: '700' }}>
              Explore How Our AI Chatbot Enhances Your Workflow
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 4, fontWeight: 'bold' }}>
              Follow these key steps to see how our chatbot simplifies tasks,
              ensures compliance, and boosts efficiency with real-time support and customizable features tailored to your needs.
            </Typography>
          </Box>
          <LandingImage src={LandingImage3} alt="Man using tech" />
        </WorkflowSection>

        {/* Footer Section */}
        <FooterSection>
          <Typography variant="h4" sx={{ mt: 3, mb: 5 }}>
            One Click Away from Optimized Operations & Performance
          </Typography>
          <Button variant="contained" color="primary" size="large" sx={{ backgroundColor: '#FF5733', mb: 5 }}>
            Explore Now
          </Button>
          <Typography variant="body2" sx={{ color: '#B7D1FF' }} >
            Proprietary product of Vegas Connit. For more information, reach out at contact@vegasgcg.com
          </Typography>
        </FooterSection>
      </StyledContainer>
    </>
  );
};

export default LandingPage;
